import React from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

import useAuth from "../../context/authContext";
import useFirebase, { AvailableConfigs } from "../../context/firebaseContext";

import { Dev } from "../../util/consoleUtil";
import { UtilComponents } from "../../util/utilComponents";

import { ContainerNodeProps } from "../../../types/common";

type RequireConfigProps = ContainerNodeProps & { config: AvailableConfigs };

export default function RequireConfig({ children, config }: RequireConfigProps) {
  const navigate = useNavigate();

  const { getConfig } = useFirebase();
  const { currentUserState } = useAuth();

  const location = useLocation();

  React.useEffect(() => {
    if (!getConfig(config) && !UtilComponents.isStaff(currentUserState)) navigate("/");
  }, []);

  if (!getConfig(config) && !UtilComponents.isStaff(currentUserState)) {
    console.log(...new Dev("This route require the follow remote config:", config).Error());

    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children as JSX.Element;
}
